import { all, call, put, takeLatest, fork } from 'redux-saga/effects';
import {
  Creators as ApplicationBiogasActions,
  Types as ApplicationBiogasTypes,
} from 'store/ducks/ApplicationBiogas';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getApplicationBiogas({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/biogas-applications`, {
      params: payload,
    });
    if (status === 200) {
      yield put(ApplicationBiogasActions.getApplicationBiogasListSuccess(data));
    } else {
      Sentry.captureMessage('getApplicationBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(ApplicationBiogasActions.getApplicationBiogasListFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(ApplicationBiogasActions.getApplicationBiogasListFail());
  }
}

function* deleteApplicationBiogas({ payload }) {
  try {
    const { status } = yield call(api.delete, `/biogas-applications/${payload}`);
    if (status === 200) {
      yield put(ApplicationBiogasActions.deleteApplicationBiogasSuccess());
    } else {
      Sentry.captureMessage('deleteApplicationBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(ApplicationBiogasActions.deleteApplicationBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(ApplicationBiogasActions.deleteApplicationBiogasFail());
  }
}

function* createApplicationBiogas({ payload }) {
  try {
    const { status } = yield call(api.post, '/biogas-applications', payload);
    if (status === 200) {
      yield put(ApplicationBiogasActions.createApplicationBiogasSuccess());
    } else {
      Sentry.captureMessage('createApplicationBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(ApplicationBiogasActions.createApplicationBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(ApplicationBiogasActions.createApplicationBiogasFail());
  }
}

function* getIdApplicationBiogas({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/biogas-applications/${payload}`);
    if (status === 200) {
      yield put(ApplicationBiogasActions.getIdApplicationBiogasSuccess(data));
    } else {
      Sentry.captureMessage('getIdApplicationBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(ApplicationBiogasActions.getIdApplicationBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(ApplicationBiogasActions.getIdApplicationBiogasFail());
  }
}

function* updateApplicationBiogas({ payload }) {
  try {
    const { status } = yield call(
      api.put,
      `/biogas-applications/${payload.id}`,
      payload.data
    );
    if (status === 200) {
      yield put(ApplicationBiogasActions.updateApplicationBiogasSuccess());
    } else {
      Sentry.captureMessage('updateApplicationBiogas failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(ApplicationBiogasActions.updateApplicationBiogasFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(ApplicationBiogasActions.updateApplicationBiogasFail());
  }
}

function* getApplicationBiogasWatcher() {
  yield takeLatest(ApplicationBiogasTypes.GET_APPLICATION_BIOGAS_LIST_REQUEST, getApplicationBiogas);
}

function* deleteApplicationBiogasWatcher() {
  yield takeLatest(ApplicationBiogasTypes.DELETE_APPLICATION_BIOGAS_REQUEST, deleteApplicationBiogas);
}

function* createApplicationBiogasWatcher() {
  yield takeLatest(ApplicationBiogasTypes.CREATE_APPLICATION_BIOGAS_REQUEST, createApplicationBiogas);
}

function* getIdApplicationBiogasWatcher() {
  yield takeLatest(ApplicationBiogasTypes.GET_ID_APPLICATION_BIOGAS_REQUEST, getIdApplicationBiogas);
}

function* updateApplicationBiogasWatcher() {
  yield takeLatest(ApplicationBiogasTypes.UPDATE_APPLICATION_BIOGAS_REQUEST, updateApplicationBiogas);
}

export default function* rootSaga() {
  yield all([
    fork(getApplicationBiogasWatcher),
    fork(deleteApplicationBiogasWatcher),
    fork(createApplicationBiogasWatcher),
    fork(getIdApplicationBiogasWatcher),
    fork(updateApplicationBiogasWatcher),
  ]);
}
